
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.825 8.535a8.083 8.083 0 01-.278-.533v-.004a9.368 9.368 0 011.449-2.164C4.061 4.652 5.686 3.5 8 3.5c2.314 0 3.94 1.152 5.004 2.334a9.368 9.368 0 011.448 2.164l.001.002v.002a9.368 9.368 0 01-1.449 2.164C11.939 11.348 10.314 12.5 8 12.5c-2.314 0-3.938-1.152-5.003-2.335a9.367 9.367 0 01-1.17-1.63zm13.639-.721L14.998 8l.464.186v.002l-.002.004-.006.014-.02.049a9.048 9.048 0 01-.39.773 10.366 10.366 0 01-1.299 1.806C12.561 12.152 10.686 13.5 8 13.5s-4.56-1.348-5.746-2.665a10.37 10.37 0 01-1.61-2.407 6.062 6.062 0 01-.1-.222l-.005-.014-.002-.004v-.001L.998 8l-.464-.186.001-.002.002-.004.006-.014a3.666 3.666 0 01.099-.222 10.368 10.368 0 011.61-2.406C3.438 3.848 5.313 2.5 7.999 2.5s4.562 1.348 5.747 2.666a10.364 10.364 0 011.61 2.406c.035.073.06.132.079.173l.02.049.006.014.002.004v.001zM14.998 8l.465-.186.074.186-.074.186L14.999 8zM.535 7.814L1 8l-.464.186L.461 8l.074-.186zM8 10a2 2 0 100-4 2 2 0 000 4z","fill":"currentColor"}})])
          )
        }
      }
    